import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import '../../styles/Pages.css';

function LibraryPage() {
    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › Academics › Library</p>
                <h1>Library</h1>
                <p>A rich repository of knowledge — books, journals, and digital resources.</p>
            </div>
            <div className="page-content">
                <div className="info-card">
                    <h2>About the Library</h2>
                    <p>
                        In higher education, the library plays a central role in academic progress. The library of Shri Mulikadevi Mahavidyalaya, Nighoj has been continuously expanding its collection and digital resources. The library provides a calm and well-lit study environment conducive to learning.
                    </p>
                </div>
                <div className="cards-grid">
                    {[
                        { icon: '📖', title: 'Books', desc: '10,000+ titles across all departments' },
                        { icon: '📰', title: 'Journals & Periodicals', desc: 'National and state-level journals' },
                        { icon: '💻', title: 'Digital Resources', desc: 'Internet-enabled computers for research' },
                        { icon: '🗂️', title: 'Reference Section', desc: 'Encyclopaedias, dictionaries, atlases' },
                        { icon: '🏛️', title: 'Reading Hall', desc: 'Spacious reading hall for students' },
                        { icon: '📋', title: 'Issue/Return', desc: 'Barcode-based book issue & return' },
                    ].map(r => (
                        <div className="grid-card" key={r.title}>
                            <div style={{ fontSize: '1.8rem', marginBottom: '0.4rem' }}>{r.icon}</div>
                            <h3>{r.title}</h3>
                            <p>{r.desc}</p>
                        </div>
                    ))}
                </div>
                <div className="info-card" style={{ marginTop: '1.5rem' }}>
                    <h2>Library Timings</h2>
                    <table className="data-table">
                        <thead><tr><th>Day</th><th>Timings</th></tr></thead>
                        <tbody>
                            <tr><td>Monday – Friday</td><td>08:00 AM – 06:00 PM</td></tr>
                            <tr><td>Saturday</td><td>09:00 AM – 01:00 PM</td></tr>
                            <tr><td>Sunday / Holidays</td><td>Closed</td></tr>
                        </tbody>
                    </table>
                </div>
                <div className="info-card">
                    <h2>Library Rules</h2>
                    <ul>
                        <li>Maintain silence inside the library at all times.</li>
                        <li>Mobile phones must be switched to silent mode.</li>
                        <li>Books must be returned within the stipulated due date.</li>
                        <li>Loss/damage of library books will attract a fine as per library policy.</li>
                        <li>Students must carry their college ID card to issue books.</li>
                    </ul>
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default LibraryPage;
